/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Share_Share_RecordInputs */

const en_us2_share_share_record = /** @type {(inputs: Share_Share_RecordInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Share the record on ${i?.name}`)
};

const pt_br2_share_share_record = /** @type {(inputs: Share_Share_RecordInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Compartilhar o recorde em ${i?.name}`)
};

const es_419_share_share_record = /** @type {(inputs: Share_Share_RecordInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Compartir el récord en ${i?.name}`)
};

const pt_pt2_share_share_record = /** @type {(inputs: Share_Share_RecordInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Partilhar o recorde em ${i?.name}`)
};

const fr_fr2_share_share_record = /** @type {(inputs: Share_Share_RecordInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Partager le record sur ${i?.name}`)
};

const de_de2_share_share_record = /** @type {(inputs: Share_Share_RecordInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rekord bei ${i?.name} teilen`)
};

const it_it2_share_share_record = /** @type {(inputs: Share_Share_RecordInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Condividi il record di ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Share the record on {name}" |
*
* @param {Share_Share_RecordInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const share_share_record = /** @type {((inputs: Share_Share_RecordInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Share_RecordInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_share_share_record(inputs)
	if (locale === "es-419") return es_419_share_share_record(inputs)
	if (locale === "pt-PT") return pt_pt2_share_share_record(inputs)
	if (locale === "fr-FR") return fr_fr2_share_share_record(inputs)
	if (locale === "de-DE") return de_de2_share_share_record(inputs)
	if (locale === "it-IT") return it_it2_share_share_record(inputs)
	return en_us2_share_share_record(inputs)
});
export { share_share_record as "share.share_record" }